import { useState } from 'react';
import { TakeTourFullForm } from './take-tour-full-form';
import { FORM_HANDLER_API_URL } from '../../../util/defaults';
import { iconSend } from '../../../util/icons';

export interface TakeTourFormPostErrorResponse {
  type: string;
  title: string;
  fields: {
    listingtaketourname: string;
    listingtaketourphone: string;
    listingtaketouremail: string;
    listingtaketourworkingwithrealtor: string;
    listingtaketourmessage: string;
  };
}

export interface TakeTourProps {
  address: string;
  mlsId: string;
  close(): void;
}

export const TakeTour = (props: TakeTourProps) => {

  const [errorResponse, setErrorResponse] = useState<TakeTourFormPostErrorResponse | null>(null);
  const [message, setMessage] = useState("I would like to take a tour of " + props.address + " (MLS: " + props.mlsId + ").");
  const [step, setStep] = useState('initial');

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [workingWithRealtor, setWorkingWithRealtor] = useState('');

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const body = {
      "form_key": "listing-taketour",
      "data": {
        form_name: 'Listing: Take Tour',
        form_url: window.location.href,
        name: name,
        phone: phone,
        email: email,
        working_with_realtor: workingWithRealtor,
        message: message
      }
    };

    fetch(FORM_HANDLER_API_URL, {
      method: "POST",
      body: JSON.stringify(body)
    }).then((response) => {
      if (response.status === 201) {
        errorResponse !== null &&
          setErrorResponse(null);
        setStep('completed');
      } else if (response.status === 422) {
        response.json().then(e => setErrorResponse(e));
      }
    }).catch((error) => {
      // console.log(error);
    });
  };

  const cancelFullForm = () => {
    setStep('');
  };


  if (step === 'completed') {
    return <div className="alert-success">Your request to take a tour has been completed.  A representative will be reaching out to you shortly to confirm availability and schedules.</div>
  } else if (step === 'information') {
    return <TakeTourFullForm
      address={props.address}
      name={name}
      phone={phone}
      email={email}
      message={message}
      workingWithRealtor={workingWithRealtor}
      errorResponse={errorResponse}
      setName={setName}
      setPhone={setPhone}
      setEmail={setEmail}
      setMessage={setMessage}
      onSubmit={onSubmit}
      close={cancelFullForm}
      setWorkingWithRealtor={setWorkingWithRealtor}
    />
  } else {
    return <div>
      <div>
        <textarea value={message} onChange={e => setMessage(e.target.value)} />
      </div>
      <div className="contact-request-buttons">
        <button onClick={() => setStep('information')} className="button-confirm">{iconSend} Send Message</button>
      </div>
    </div>
  }
}
